import { Outlet, createFileRoute } from "@tanstack/react-router";
import { AdminLayout } from "@/components/admin/AdminSidebar";
import { MarketChat } from "@/components/admin/MarketChat";
import { AdminAuthGate } from "@/components/admin/AuthGate";
import { EntityPeekProvider } from "@/components/admin/entity-peek/EntityPeekContext";
import { EntityPeekSheet } from "@/components/admin/entity-peek/EntityPeekSheet";


export const Route = createFileRoute("/admin")({
  validateSearch: (search: Record<string, unknown>): { miembro?: string; agencia?: string } => ({
    miembro: typeof search.miembro === "string" ? search.miembro : undefined,
    agencia: typeof search.agencia === "string" ? search.agencia : undefined,
  }),
  head: () => ({
    meta: [
      { title: "Admin — Bizaclia" },
      { name: "description", content: "Panel de administración de Bizaclia." },
      { name: "robots", content: "noindex,nofollow" },
    ],
  }),
  component: () => (
    <AdminAuthGate>
      <EntityPeekProvider>
        <AdminLayout>
          <Outlet />
          <MarketChat />
        </AdminLayout>
        <EntityPeekSheet />
      </EntityPeekProvider>
    </AdminAuthGate>
  ),
});
